// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "pfx-Subscription-module__body--Yc3F3";
var _3 = "1260px";
var _4 = "1020px";
var _5 = "668px";
var _6 = "1550px";
var _7 = "pfx-Subscription-module__buttons--dRcbz";
var _8 = "pfx-Subscription-module__container--UM0o0";
var _9 = "1140px";
var _a = "940px";
var _b = "100%";
var _c = "15px";
var _d = "620px";
var _e = "#f53535";
var _f = "rgba(0,0,0,.2)";
var _10 = "rgba(255,255,255,.38)";
var _11 = ".38";
var _12 = "rgba(255,255,255,.2)";
var _13 = "#0025ff";
var _14 = "#f60";
var _15 = "#41ead4";
var _16 = "#2cdd78";
var _17 = "#66ab23";
var _18 = "#f5f5f5";
var _19 = "#c3c3c3";
var _1a = "#ececec";
var _1b = "#252525";
var _1c = "#272727";
var _1d = "#c6c6c5";
var _1e = "#333";
var _1f = "#3c3c3c";
var _20 = "#9c9b9b";
var _21 = "#8c8c8c";
var _22 = "#6f6f6e";
var _23 = "#3c3c3b";
var _24 = "#373737";
var _25 = "#6a6a69";
var _26 = "#6f6f6f";
var _27 = "#9f9e9e";
var _28 = "#282828";
var _29 = "#828181";
var _2a = "#1d1d1d";
var _2b = "#979797";
var _2c = "#9c9b9b";
var _2d = "#a7a7a6";
var _2e = "#c6c6c5";
var _2f = "#d8d8d7";
var _30 = "#dddddc";
var _31 = "72px";
var _32 = "40px";
var _33 = "36px";
var _34 = "25px";
var _35 = "18px";
var _36 = "13px";
var _37 = "#0025ff";
var _38 = "rgba(255,255,255,.12)";
var _39 = "#6535f5";
var _3a = "pfx-Subscription-module__logo--EGRkM";
var _3b = "2px";
var _3c = "56px";
var _3d = "56px";
var _3e = "#41ead4";
var _3f = "#f60";
var _40 = "#f83600";
var _41 = "#881f00";
var _42 = "18px";
var _43 = "15px";
var _44 = "red";
var _45 = "13px";
var _46 = "rgba(255,255,255,.07)";
var _47 = "pfx-Subscription-module__title--Zw_zc";
var _48 = "pfx-Subscription-module__top--ENszP";
var _49 = "#35465c";
var _4a = "#55acee";
var _4b = "#fff";
var _4c = "#ffce36";
var _4d = "#ffcd00";
var _4e = "red";
export { _1 as "black", _2 as "body", _3 as "breakLarge", _4 as "breakMedium", _5 as "breakSmall", _6 as "breakVLarge", _7 as "buttons", _8 as "container", _9 as "containerLarge", _a as "containerMedium", _b as "containerMobile", _c as "containerPaddingMobile", _d as "containerSmall", _e as "danger", _f as "darkElement", _10 as "disabled", _11 as "disabledOpacity", _12 as "extraLightElement", _13 as "facebook", _14 as "google", _15 as "green", _16 as "green2", _17 as "greenColor", _18 as "grey1", _19 as "grey10", _1a as "grey2", _1b as "grey25", _1c as "grey27", _1d as "grey3", _1e as "grey33", _1f as "grey3C", _20 as "grey4", _21 as "grey41", _22 as "grey5", _23 as "grey6", _24 as "grey61", _25 as "grey6A", _26 as "grey6F", _27 as "grey7", _28 as "grey8", _29 as "grey82", _2a as "grey9", _2b as "grey97", _2c as "grey9C", _2d as "greyA7", _2e as "greyC6", _2f as "greyD8", _30 as "greyDd", _31 as "header1", _32 as "header2", _33 as "header3", _34 as "header4", _35 as "header5", _36 as "header6", _37 as "klein", _38 as "lightElement", _39 as "lilac", _3a as "logo", _3b as "menuBorder", _3c as "menuHeight", _3d as "menuMobileHeight", _3e as "ocean", _3f as "orange", _40 as "orange2", _41 as "orangeDark", _42 as "paragraph", _43 as "paragraphSmall", _44 as "red", _45 as "subHeaderSmall", _46 as "subtleLightElement", _47 as "title", _48 as "top", _49 as "tumblr", _4a as "twitter", _4b as "white", _4c as "yellow", _4d as "yellowDeep", _4e as "youtube" }
